import api from './api';

const canonicalService = {
  // Get all canonicals with optional filters
  getAllCanonicals: async (filters = {}) => {
    const params = new URLSearchParams();

    if (filters.name) {
      params.append('name', filters.name);
    }

    const queryString = params.toString();
    const url = queryString ? `/admin/canonical?${queryString}` : '/admin/canonical';

    return api.get(url);
  },

  // Get a single canonical by ID
  getCanonicalById: async (id) => {
    return api.get(`/admin/canonical/${id}`);
  },

  // Create a new canonical
  createCanonical: async (canonicalData) => {
    return api.post('/admin/canonical', canonicalData);
  },

  // Update an existing canonical
  updateCanonical: async (id, canonicalData) => {
    return api.put(`/admin/canonical/${id}`, canonicalData);
  },

  // Delete a canonical
  deleteCanonical: async (id) => {
    return api.delete(`/admin/canonical/${id}`);
  }
};

export default canonicalService;
